<template>
<div class="chapter">
<div class="inner_page">
<h1 class="P_Heading_1" id="auto_bookmark_toc_1"><span>The Doctor’s Secret</span></h1>
<p class="P_Normal"> </p>
<p class="P_Norm-NoIndent">By Heidi Cullinan</p>
<p class="P_Norm-NoIndent">Copper Point Medical: Book One</p>
<p class="P_Normal"> </p>
<p class="P_Normal">The brilliant but brooding new doctor encounters Copper Point’s sunny nurse-next-door… and nothing can stand in the way of this romance.</p>
<p class="P_Normal">Dr. Hong-Wei Wu has come to Copper Point, Wisconsin, after the pressures of a high-powered residency burned him out of his career before he started. Ashamed of letting his family down after all they’ve done for him, he plans to live a quiet life as a simple surgeon in this tiny northern town. His plans, however, don’t include his outgoing, kind, and attractive surgical nurse, Simon Lane.</p>
<p class="P_Normal">Simon wasn’t ready for the new surgeon to be a handsome charmer who keeps asking him for help getting settled and who woos him with amazing Taiwanese dishes. There’s no question—Dr. Wu is flirting with him, and Simon is flirting back. The problem is, St. Ann’s has a strict no-dating policy between staff, which means their romance is off the table… unless they bend the rules.</p>
<p class="P_Normal">But a romance that keeps them—literally—in the closet can’t lead to happy ever after. Simon doesn’t want to stay a secret, and Hong-Wei doesn’t want to keep himself removed from life, not anymore. To secure their happiness, they’ll have to change the administration’s mind. But what other secrets will they uncover along the way, about Copper Point… and about each other?</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section-0002.vue?64618de0